import axios from 'axios';

export async function uploadFileToS3(url, file) {
    try {
        const uploadResponse = await axios.put(url, file);

        if (uploadResponse.status === 200) {
            console.log('File uploaded successfully!');
        } else {
            console.error('Upload failed');
        }
    } catch (error) {
        console.error('Upload failed:', error);
        throw error;
    }
}
